/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplatesControllerExportToExcelQueryResponse, TemplatesControllerExportToExcelPathParams } from "../../models/checklistsController/TemplatesControllerExportToExcel";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { templatesControllerExportToExcel } from "../../clients/checklistsService/templatesControllerExportToExcel";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const templatesControllerExportToExcelQueryKey = (id: TemplatesControllerExportToExcelPathParams["id"]) => [{
  url: '/api/v1/checklist-templates/:id/excel',
  params: {
    id: id
  }
}] as const;
export type TemplatesControllerExportToExcelQueryKey = ReturnType<typeof templatesControllerExportToExcelQueryKey>;
export function templatesControllerExportToExcelQueryOptions(id: TemplatesControllerExportToExcelPathParams["id"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = templatesControllerExportToExcelQueryKey(id);
  return queryOptions<TemplatesControllerExportToExcelQueryResponse, ResponseErrorConfig<Error>, TemplatesControllerExportToExcelQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return templatesControllerExportToExcel(id, config);
    }
  });
}

/**
 * @description Generates a multi-tab Excel file containing the checklist template with sections, answer types, questions, and prompts.
 * @summary Export checklist template to Excel
 * {@link /api/v1/checklist-templates/:id/excel}
 */
export function useTemplatesControllerExportToExcel<TData = TemplatesControllerExportToExcelQueryResponse, TQueryData = TemplatesControllerExportToExcelQueryResponse, TQueryKey extends QueryKey = TemplatesControllerExportToExcelQueryKey>(id: TemplatesControllerExportToExcelPathParams["id"], options: {
  query?: Partial<QueryObserverOptions<TemplatesControllerExportToExcelQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? templatesControllerExportToExcelQueryKey(id);
  const query = useQuery({
    ...templatesControllerExportToExcelQueryOptions(id, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}